/*function stripSylviePrefix() {
  document.querySelectorAll('legend.form__label span').forEach(el => {
    const text = el.textContent.trim();
    if (/^Sylvie\s+/i.test(text)) {
      el.textContent = text.replace(/^Sylvie\s+/i, '');
    }
  });
}

document.addEventListener('DOMContentLoaded', stripSylviePrefix);

const sylvieObserver = new MutationObserver(stripSylviePrefix);
sylvieObserver.observe(document.body, { childList: true, subtree: true });*/


function stripSylviePrefix() {
  document.querySelectorAll('legend.form__label span').forEach(el => {
    const text = el.textContent.trim();
    if (/^Sylvie\s+/i.test(text)) {
      el.textContent = text.replace(/^Sylvie\s+/i, '');
    }
  });
}

function fixColorSwatches() {
  // Add your custom non-standard color hexes here:
  const customHexes = {
    'oatmeal': '#D4C5B0',
    'iceblue': '#B8D4E3',
    'air': '#E8F4F8',
    'taupe': '#B5A89A',
    'eucalyptus': '#7DAF9C',
    'eucalyptusgreen': '#A8B8A0',
    'gravity': '#6B2737',
    'earth': '#5B7FA6',
    'toffee': '#C49A6C',
    'peacock': '#2A8B8B',
    'dune': '#C4B49A',
    'pastelgreen': '#B8D4B0',
    'classicgrey': '#A8A8A8',
    'powder': '#B8D0E8',
    'natural': '#F0EAD6',
    'mineral': '#8B96A3',
    'stone': '#6B6B6B',
    'shore': '#8FA8B8',
    'pewter': '#9A9E98',
    'white': '#FAF7F2',
    'milky': '#FAF7F2',
    'whitewhite': '#FAF7F2',
    'whitenavy': '#4A5561',
    'green53cm': '#2A8B8B',
    'orange53cm': '#F28C38',
    'gray53cm': '#C0C0C0',
    'apricotcolor53cm': '#E8A878',
    'ivorystripe': '#FFF5E1',
    'reddiamond': '#B03030',
    'blackdiamond': '#2A2A2A',
    'middlelinen': '#CFC4A8',
    'linenstripe': '#DDD3BC',
    'beigedesign': '#D4C9B0',
    'browntexture': '#5C3D2A',
    'sanddesign': '#C8B89A',
    'beigetexture': '#D4C9B0',
    'taupedesign': '#B5A89A',
    'sandtexture': '#C8B89A',
    'aqua': '#5FBFBF',
    'rust': '#B5451B',
    'amber': '#C17F24',
    'cranberry': '#8F4545',
    'flutedvasetall': '#B8CC9A',
    'fruitbowl': '#B8CC9A',
    'flutedvaseshort': '#B8CC9A',
    'cream': '#F5F0E4',
    'mediumblue': '#5B8AB5',
    'mossgreen': '#7A8C5C',
    'chocolatebrown': '#5C3520',
    'warmbeige': '#D4C4A8',
    'palegreen': '#C8D8B8',
    'sand': '#C8B89A',
    'wood': '#8B6340',
    'brushedgold': '#C9A96E',
    'peach': '#F2C4A8',
    'beige25': '#D4C9B0',
    'onyxwhite25': '#F0EDE8',
    'calacattagreen25': '#8FA882',
    'creamrose25': '#E8C4B8',
    'calacattared25': '#B5453A',
    'indiangreen28': '#4A7A5A',
    'rossolepanto28': '#7A3828',
    'blackwhite25': '#6B6B6B',
    'whiteonyx25': '#EDE8E0',
    'pitayaflower25': '#D8D4CE',
    'treeblack25': '#2A2A2A',
    'neromarquina25': '#1A1A1A',
    'volakoswhite25': '#F5F0E8',
    'blackwhite30': '#6B6B6B',
    'indiangreen30': '#4A7A5A',
    'volakoswhite30': '#F5F0E8',
    'whiteonyx28': '#EDE8E0',
    'beige28': '#D4C9B0',
    'beige': '#D4C9B0',
    'beigehalf': '#D4C9B0',
    'incenseburner': '#D4C9B0',
    'matchholder': '#D4C9B0',
    'bamboo': '#C8D8B8',
    'yellowfruit': '#D4AF37',
    'redtravertine': '#B5453A',
    'portoro': '#4A3228',
    'emeraldgreen': '#4A9A6A',
    'apricot': '#E8A878',
    'papyrus': '#D4C49A',
    'offwhite': '#F0EBE0',
    'naturalwood': '#C4956A',
    'beige-geometric': '#D4BE98',
    'tan': '#B58B5F',
    'claybrown': '#946B54',
    'brown': '#946B54',
    'browndecal': '#946B54',
    'redflowers': '#B5453A',
    'clear': '#E8E8E8',
    'smoke': '#5E5E5E',
    'oliveoil': '#A3966A',
    'siennaleather': '#A65E3E',
    'cloudlinen': '#B7B9B8', // note: second rule in CSS had #8A9A5B
    'graphiteweave': '#53565A',
    'olivegrove': '#74824A',
    'obsidianlinen': '#3D3F42',
    'buddingsage': '#C2CFA0',
    'mistwisteria': '#A899B5',
    'naturalivory': '#F5F2E9',
    'greyivory': '#BDC3C7',
    'charcoalltgrey': '#6B6B6B',
    'navyltblue': '#1B3A52',
    'forestmoss': '#74824A',
    'mochabark': '#946B54',
    'burgundyplum': '#8B4F6D',
    'deepcurrant': '#582C2D',
    'alabasterwhite': '#F5F2E9',
    'winterwhite': '#F5F2E9',
    'duskrose': '#D4A5A5',
    'stormgray': '#5E676B',
    'clovebrown': '#4E3B31',
    'oatmealbeige': '#D2B48C',
    'currantred': '#582C2D',
    'deepindigoblue': '#1B2B42',
    'sunbleachedochre': '#D9C589',
    'crimsonclay': '#8B2635',
    'deepearth': '#4B3D33',
    'basaltumber': '#5D544F',
    'mossalabaster': '#EAECE6',
    'prismiridescent': 'linear-gradient(135deg, #E0F7FA 0%, #FCE4EC 50%, #FFF9C4 100%)',
    'solaramber': '#D4A373',
    'lunarsmoke': '#5A5A5A',
    'crystalclear': '#FFFFFF',
    'purealabaster': '#F7F5F2',
    'fossilgrey': '#A9A9A9',
    'mustardgreen': '#8B864E',
    'dustyrose': '#D8B4B4',
    'deepcurrant': '#722F37',
    'sandstone': '#8B7355',
    'slateblue': '#708090',
    'midnightcobalt': '#2C3E50',
    'khaki': '#C3B091',
    'americanharvest': '#D2B48C',
    'patriotblue': '#6B7B8E',
    'mountaingrey': '#8E8E8E',
    'seafoamgreen': '#B5BFB1',
    'ochre': '#D4AF37',
    'cacao': '#4B3621',
    'alabaster': '#EAE3D2',
    'pumice': '#9E9E9E',
    'terracotta': '#C1663B',
    'juniper': '#6D8B84',
    'sky': '#B0C4DE',
    'slate': '#8C8C8C',
    'mist': '#D1D5D6',
    'driftwood': '#A69586',
    'amethyst': '#7D6B7D',
    'citrine': '#D4C35F',
    'rose': '#D9B8B5',
    'azure': '#6A92C2',
    'coffee': '#704214',
    'ivory': '#FFF5E1',
    'pristineivory': '#FFF5E1',
    'pewter': '#C0C0C0',
    'mustard': '#E3B448',
    'mosstulip': '#6B705C',
    'indigocrest': '#4682B4',
    'earthprint': '#A68A64',
    'wildrose': '#F4C2C2',
    'ambergrove': '#D4A373',
    'sirobrown': '#6B4F3B',
    'green-white': '#B2BDAD',
    'blush-white': '#D8B4A6',
    'blue-grey': '#4F6D82',
    'grey-white': '#BDC3C7',
    'feather': '#F8F9F9',
    'dove': '#D5D6D2',
    'cashmere': '#DCDCDC',
    'buff': '#E3D4B6',
    'charcoal': '#6B6B6B',
    'fir': '#34492E',
    'clove': '#5D4037',
    'dusty-mauve': '#8C717A',
    'dusk': '#4E5E77',
    'pomegranate': '#5D0E1E',
    'rouge': '#E2B4B4',
    'currant': '#C11B17',
    'copper': '#B87333',
    'indigo': '#1B2E4B',
    'cameo': '#DDBBBA',
    'moonbeam': '#F4F4F2',
    'ginger': '#B5651D',
    'sun-kissed': '#E9967A',
    'golden': '#D4AF37',
    'surf': '#8DA399',
    'khmer': '#8B4513',
    'mudcloth': '#4A4A4A', // note: second rule in CSS had #E5E4E2
    'swisscross': '#D3D3D3',
    'grayleopard': '#C0C0C0',
    'classicleopard': '#7B3F00',
    'tanleopard': '#D2B48C',
    'snow': '#F9F9F9',
    'flax': '#E6E0D4',
    'sandshellblend': '#DCCFB1',
    'cobblestone': '#5A5A5A',
    'chocolateblend': '#4B3621',
    'forest': '#2E3B2E',
    'montanacoles': '#C19A8B',
    'woodrose': '#9A808E',
    'royale': '#5D0E1E',
    'clay': '#D38E7D',
    'hazelnut': '#8E735B',
    'buttermilk': '#F6F1E3',
    'chiffon': '#F8EDD1',
    'balletslipper': '#D9A0A8',
    'blossom': '#E9B2A6',
    'bloom': '#9D84A1',
    'fairywings': '#A984B8',
    'primrose': '#C14271',
    'fern': '#4F5D44',
    'hunter': '#435D56',
    'stormcloud': '#92A1B1',
    'rosy': '#B38673',
    'chambray': '#A3C1D4',
    'dew': '#C0D6DF',
    'seagrass': '#98B08E',
    'aubergine': '#4B2E4D',
    'nauticalblue': '#1B2E4B',
    'frenchrose': '#B27A78',
    'spruce': '#5F8A8B',
    'sprucegreen': '#4A6B56',
    'darktaupe': '#7A6F66',
    'frostgrey': '#A6998F',
    'birch': '#CDBBA7',
    'hibiscus': '#D67B7B',
    'cloudwhite': '#F8F9F5',
    'claritywhite': '#F8F9F5',
    'mossgreen': '#4A5D23',
    'sagegreen': '#9CAF88',
    'almondbrown': '#AF8A6B',
    'saffronyellow': '#D4A017',
    'oceanblue': '#1E3452',
    'cameo': '#DDBBBA',
    'ginger': '#B5651D',
    'golden': '#D4AF37',
    'butteryellow': '#F3E5AB',
    'moon': '#E2E2E2',
    'cloud': '#F8F9F5',
    'gold': '#DAA520',
    'copper': '#C87137',
    'branches': '#C4A682',
    'birchtrail': '#A8C5D8',
    'cappuccino': '#C4A682',
    'denimblue': '#4A7BA7',
    'bluetone': '#4A7BA7',
    'bluepeach': '#4A7BA7',
    'redtone': '#D61E6F',
    'mauve': '#9B7BA7',
    'steel': '#5A7A8E',
    'jade': '#5A8B7F',
    'mocha': '#8B7355',
    'glacier': '#7BA9B8',
    'champagne': '#D4B896',
    'blush': '#C9999F',
    'naturalcotton': '#FFF5ED', 
    'deeprose': '#D36B78',
    'goldenochre': '#C6934B',
    'warmsand': '#E6B9A6',
    'mutedcoral': '#DB8671',
    'toastedalmond': '#A67E5F',
    'dustymauve': '#8C717A',
    'adobetan': '#BF9B7A',
    'adobegreen': '#4F5D4B',
    'lavender': '#BDB5D5',
    'fuchsia': '#D61E6F',
    'pinkrose': '#E6B199',
    'rosepink': '#E6B199',
    'gray': '#929791',
    'rust': '#8B452D',
    'red': '#D32F2F',
    'orange': '#F28C38',
    'daisy': '#F2C94C',
    'yellow': '#F7E3AF',
    'lime': '#C5D96B',
    'pear': '#6B9E45',
    'mint': '#A8DADC',
    'periwinkle': '#93B5D1',
    'pinkfrost': '#9B7575',
    'ocean': '#4A90E2',
    'mauvemarble': '#E2C2C1',
    'whitemarble': '#F2F2F2',
    'denimmarble': '#B2C2D1',
    'yellowmarble': '#E8D1A7',
    'graymarble': '#C2C2C2',
    'pinkmarble': '#E6B199',
    'obsidian': '#1A1A1A',
    'midnightbloom': '#2D3E50',
    'autumnalflora': '#B5612D',
    'lavendermeadow': '#6B5B95',
    'duskpetal': '#7E4A82',
    'wildwood': '#8B4513',
    'ash': '#8E9191',
    'claymidnight': '#B2847B',
    'plumsky': '#8E5A8E',
    'blueblack': '#708090',
    'pinkgrey': '#DCAEAE',
    'greenblack': '#9CAF88',
    'greyblack': '#8E9191',
    'pinkblue': '#C18D94',
    'purplegrey': '#7E6B8F',
    'pistachiomoss': '#C1D97A',
    'cyanslate': '#4FB3BF',
    'peonyorchid': '#DDA0DD',
    'cobaltember': '#4A90E2',
    'azuremint': '#A0E7E5',
    'brushedsilver': '#C0C0C0',
    'darkchocolate': '#472B1D',
    'charcoalgray': '#6B6B6B',
    'sagegreen': '#77815C',
    'magnoliawhite': '#F8F4FF',
    'smokeblue': '#708090',
    'blue': '#2C3E50',
    'walnut': '#674C3A',
    'clearglass': '#E8F0F5',
    'frostwhite': '#EEF1F0',
    'stealthgray': '#6B7C7A',
    'midnight': '#3D5A80',
    'midnightfloral': '#3D5A80',
    'terra': '#A0653C',
    'ember': '#8B6F47',
    'stone': '#C4B5A0',
    'sanddunetan': '#C4B5A0',
    'parchment': '#D9CFC4',
    'apricot': '#D6C7B1',
    'agate': '#1E5971',
    'ochre': '#BF8226',
    'chocolate': '#5C4033',
    'pearlgray': '#CFD5D7',
    'biscotti-offwhite': '#D2B48C',
    'boulder': '#7A7F71',
    'mistyblue': '#8DA3B3', // note: second rule in CSS had #4A5561
    'offwhite': '#F7F5F2',
    'vanilla': '#DED6C9',
    'saharatan': '#D2B48C',
    'biscotti': '#B9A07E', // note: second rule in CSS had #BCC6CC
    'dew': '#A7C2D1',
    'mocha': '#6B5E4F',
    'gildedwalnut': '#D4AF37',
    'calacattared': '#A47D63',
    'calacattaviola': '#4D2D44',
    'gradientblue': '#4A6D8C',
    'pureblue': '#2E58A6',
    'gradientgreen': '#7A8B7C',
    'obsidiantint': '#3A444D',
    'naturalbeech': '#D2B48C',
    'deepwalnut': '#5D4037',
    'taupe': '#A39689',
    'cobalt': '#0052CC',
    'carbonizedbamboo': '#5D4E45',
    'beech': '#C49060',
    'primarycolor': '#E2C5A4',
    'darkcolor': '#A4683B',
    'bicolor': '#E2C39B',
    'a': '#8C432B',
    'b': '#A6563C',
    'emeraldcloud': '#D3D6D4',
    'rainygreen': '#4A5D4E',
    'blackportopo': '#5C3A21',
    'beige': '#D4C5B0',
    'gray': '#808080',
    'blue': '#6A8BB0',
    'graphite': '#595350',
    'oat': '#E6D0BC',
    'citron': '#D2B04C',
    'frosted': '#E2E4E6',
    'verdegreen': '#BACD94',
    'salmonrose': '#E2B2A2',
    'honey': '#C19E37',
    'ink': '#3B4958',
    'mica': '#E2DDD5',
    'quartz': '#DCB8B1',
    'papaya': '#BD5B32',
    'brass': '#C19A43',
    'fern': '#7A8169',
    'cypress': '#535848',
    'fig': '#5D374B',
    'night': '#383A3E',
    'softblue': '#5B7AA4',
    'navyblue': '#1B3A52',
    'steelgrey': '#D1D4D6',
    'chesapeakeblue': '#4A5561',
    'purewhite': '#F9F9F9',
    'slate': '#55575C',
    'butteryellow': '#EFE6CD',
    'softgreen': '#B9DCD0',
    'grey': '#808080',
    'harmonygrey': '#808080',
    'rosyapricot': '#D6AFA1',
    'green': '#7A8169',
    'smokygray': '#808080',
    'amber': '#E59F43',
    'khaqi': '#C3B091',
    'tuaregindigo': '#1E3D75',
    'seychellesteal': '#00A3A1',
    'savannabeige': '#B09F86',
    'ebonyblack': '#1C1C1C',
    'madagascarcoral': '#E65C4F',
    'nude': '#98644e',
    'desertoasisgreen': '#4F5D4B',
    'autumnleaf': '#C9A030',
    'bluebell': '#B8856A',
    'bluesapphire': '#4A5280',
    'mossgreen': '#8A9B7A',
    'oystershell': '#E8DCC8',
    'oysterred': '#C4956A',
    'seaspray': '#D4A870',
    'tidalpool': '#6BBFB0',
    'white': '#F5F0EA',
    'off-white': '#F7F5F2',
    'alabaster': '#F5F2E9',
    'mattewhite': '#F5F2E9',
    'matteblack': '#000000',
    'darkbronze': '#4A3728',
    'antiquebrass': '#9C7A3C',
    'sylvienatural': '#C9B79C',
    'sylviewhite': '#FAFAF8',
    'sylviegraywash': '#A8A29B',
    'sylvieblack': '#000000',
    'blacksolidwood': '#000000',
    'naturalwoodcolorsolidwood': '#D2B48C',
    'chrome': '#C4C8CC',
    'nickel': '#B9BBB6',
    'gunmetal': '#4A4E52',
    'brushednickel': '#B9BBB6',
    'pleatedbrass': '#B8960C',
    'aloe': '#A3B2A4',
    'moss': '#ABBE8C',
    'almond': '#D9CCB4',
    'mint': '#B8D4BE',
    'latte': '#7A5C4A',
    'oyster': '#D9CCB4',
    'bluish': '#7C8B96',
    'beechhandle': '#D9C7A8',
    'walnuthandle': '#6B4423',
    'lightbrown': '#C4A484',
    'greentulips': '#6B8E5A',
    'ah38cm': '#5C3D2E',
    'bh38cm': '#E8DCC8',
    'ch38cm': '#C4A882',
    'darkwalnut': '#4A2E1A',
    'butter': '#F5EDD6',
    '20x6cm': '#F5EDD6',
    '25x155cm': '#F5EDD6',
    '165x11cm': '#F5EDD6',
    '9x32cm': '#4A2E1A',
    '9x27cm': '#4A2E1A',
    'a': '#7A3E28',
    'b': '#7A3E28',
    'c': '#7A3E28',
    'd': '#7A3E28',
    '21x21x3cm': '#F5EDD6',
    '26x26x3cm': '#F5EDD6',
    '17x28cm': '#B8D4B0',
    '30x20cm': '#000000',
    '23x23cm': '#000000',
    '30x11cm': '#000000',
    '30x16cm': '#000000',
    '25x12cm': '#000000',
    '30x20x2cm': '#F5EDD6',
    '30x12x2cm': '#F5EDD6',
    '25x15x2cm': '#F5EDD6',
    'large': '#7A3E28',
    'small': '#7A3E28',
    '45x24x195cm': '#7A3E28',
    '8x9cm': '#000000',
    '7x15cm': '#000000',
    '39x36cm': '#7A3E28',
    's': '#7A3E28',
    'l': '#7A3E28',
    'm': '#7A3E28',
    '2pcsset': '#7A3E28',
    '30x20x5cmb': '#F5EDD6',
    '30x15x5cmb': '#F5EDD6',
    '30x10x15cma': '#F5EDD6',
    '30x20x15cma': '#F5EDD6',
    '30x10x5cmb': '#F5EDD6',
    'beige20': '#E8DCC8',
    'beige28': '#E8DCC8',
    'portoro20': '#2A1F14',
    'portoro25': '#2A1F14',
    'calacattared20': '#8B3A2A',
    'calacattared27': '#8B3A2A',
    'calacattaviola20': '#6B5A7A',
    'calacattaviola25': '#6B5A7A',
    'roundbeige': '#E8DCC8',
    'roundlightgrey': '#C4BFBA',
    'roundbrown': '#946B54',
    'roundgreen': '#A8D5A8',
    'naturalstraw': '#946B54',
    'primarycolorbamboothreads': '#E8DCC8',
    'naturalcarbonizedbamboosilk': '#946B54',
    'primarycolorsquare': '#E8DCC8',
    'primarycolorround': '#E8DCC8',
    'squarebeige': '#E8DCC8',
    'squarelightgrey': '#C4BFBA',
    'squarebrown': '#946B54',
    'squaregreen': '#A8D5A8',
    'blushpink': '#E8B4B8',
    'lightgrey': '#D9D3CC',
    'marigold': '#F5A623',
    'cacaobrown': '#6B3A2A',
    'sage': '#9CAF88',
    'slate': '#8C8C8C',
    'boroblue': '#2C3E50',
    'lightblue': '#B8D4E3',
    'burgundy': '#6B3D3D',
    'oystershell': '#E8DCC8',
    'oysterred': '#C4956A',
    'oystershellred': '#C4956A', // Add this entry (or whichever hex code / gradient you prefer)
    'whitea': '#FAF7F2',
    'whiteb': '#FAF7F2',
    'whitec': '#FAF7F2',
    'whited': '#FAF7F2',
    'whitee': '#FAF7F2',
    'whitef': '#FAF7F2',
    'whiteg': '#FAF7F2',
    'whiteh': '#FAF7F2',
    'whitei': '#FAF7F2',
    'whitej': '#FAF7F2',
    'whitek': '#FAF7F2',
    'whitel': '#FAF7F2',
    'whitel': '#FAF7F2',
    'whites': '#FAF7F2',
    'blackl': '#000000',
    'blacks': '#000000',
    'denimbluegrey': '#4A7BA7',
    'greywhite': '#A8A8A8',
    'bluewhite': '#9DB4A0',
    'blushwhite': '#E5DAD8',
    'cork': '#B8956A',
    'tango': '#F28C38',
    'limitededitioncobalt': '#0052CC',
    'woodencolor': '#B8956A',
    'black': '#000000'
  };

  document.querySelectorAll('input[name*="Color" i]').forEach(input => {
    const label = input.nextElementSibling;
    if (label && label.tagName === 'LABEL') {
      // Clean the input value (e.g. "Moss Green" -> "mossgreen")
      const sanitizedKey = input.value.toLowerCase().replace(/[^a-z0-9]/g, '');
      
      // Look up hex in dictionary, fallback to sanitized name
      const colorToApply = customHexes[sanitizedKey] || sanitizedKey;

      label.style.setProperty('background-color', colorToApply, 'important');
      label.style.setProperty('background-image', 'none', 'important');
    }
  });
}

function runThemeFixes() {
  stripSylviePrefix();
  fixColorSwatches();
}

document.addEventListener('DOMContentLoaded', runThemeFixes);

const sylvieObserver = new MutationObserver(runThemeFixes);
sylvieObserver.observe(document.body, { childList: true, subtree: true });